module.exports = __webpack_public_path__ + "assets/img/package-man-work.87e021dc.svg";